const berlinTimestampFormatter = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
  timeZone: 'Europe/Berlin',
});

const groupDateFormatter = new Intl.DateTimeFormat('de-DE', {
  weekday: 'long',
  day: '2-digit',
  month: 'long',
  year: 'numeric',
});

const getPart = (parts, type) => parts.find(part => part.type === type)?.value || '';

const formatAuditTimestamp = (iso) => {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  const parts = berlinTimestampFormatter.formatToParts(date);
  return `${getPart(parts, 'day')}.${getPart(parts, 'month')}.${getPart(parts, 'year')}, ${getPart(parts, 'hour')}:${getPart(parts, 'minute')}`;
};

const getAuditGroupKey = (iso) => {
  if (!iso) return 'Unbekannt';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return 'Unbekannt';
  const parts = berlinTimestampFormatter.formatToParts(date);
  return `${getPart(parts, 'year')}-${getPart(parts, 'month')}-${getPart(parts, 'day')}`;
};

const formatAuditGroupDate = (isoDate) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDate || '');
  if (!match) return isoDate || 'Unbekannt';
  const [, year, month, day] = match;
  return groupDateFormatter.format(new Date(Number(year), Number(month) - 1, Number(day), 12));
};

export {
  formatAuditTimestamp,
  formatAuditGroupDate,
  getAuditGroupKey,
};
